// containers/TotalExpenses.jsx
import React, { useEffect, useState } from "react";
import TotalExpensesBox from "../../components/GastosDatos/TotalExpensesBox";
import { getUser } from "../../../auth";

const URL = process.env.REACT_APP_API_URL;

export default function TotalExpenses() {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    const fetchTotal = async () => {
      const user = getUser();
      try {
        const res = await fetch(`${URL}/api/activity/datos/summary/total-expenses/`, {
          headers: {
            "x-empresa-id": user?.empresa_id,
          },
        });
        if (!res.ok) throw new Error("Error al obtener los gastos totales");
        const data = await res.json();
        setTotal(data.total_expenses);
      } catch (err) {
        console.error(err);
      }
    };

    fetchTotal();
  }, []);

  return <TotalExpensesBox total={total} />;
}
